import React from 'react';
import {mainGreen} from 'styles/variables';

export const ConnectionGood = props => {
    return (
        <svg width='22' height='22' viewBox='0 0 22 22' {...props}>
            <g fill='none'>
                <path
                    fill={mainGreen}
                    stroke='#FFF'
                    strokeWidth='2'
                    d='M11 2.882c-2.242 0-4.271.909-5.74 2.378C3.791 6.729 2.882 8.758 2.882 11s.909 4.271 2.378 5.74c1.469 1.469 3.498 2.378 5.74 2.378s4.271-.909 5.74-2.378c1.469-1.469 2.378-3.498 2.378-5.74s-.909-4.271-2.378-5.74C15.271 3.791 13.242 2.882 11 2.882z'
                />
                <path
                    fill='#FFF'
                    d='M9.87 10.086L13.969 14.25 13.24 14.99 8.412 10.086 11.333 7.118 12.062 7.858z'
                    transform='rotate(-90 11.19 11.054)'
                />
            </g>
        </svg>
    );
};

export const ConnectionMedium = props => {
    return (
        <svg width='22' height='22' viewBox='0 0 22 22' {...props}>
            <g fill='none'>
                <path
                    fill='#FFC72C'
                    stroke='#FFF'
                    strokeWidth='2'
                    d='M11 2.882c-2.242 0-4.271.909-5.74 2.378C3.791 6.729 2.882 8.758 2.882 11s.909 4.271 2.378 5.74c1.469 1.469 3.498 2.378 5.74 2.378s4.271-.909 5.74-2.378c1.469-1.469 2.378-3.498 2.378-5.74s-.909-4.271-2.378-5.74C15.271 3.791 13.242 2.882 11 2.882z'
                />
                <path
                    fill='#FFF'
                    d='M10.353 7.118l1.294.004v5.172h-1.294V7.118zm0 6.47l1.294.001v1.293h-1.294v-1.294z'
                />
            </g>
        </svg>
    );
};

export const ConnectionBad = props => {
    return (
        <svg width='22' height='22' viewBox='0 0 22 22' {...props}>
            <g fill='none'>
                <path
                    fill='#F55A5A'
                    stroke='#FFF'
                    strokeWidth='2'
                    d='M11 2.882c-2.242 0-4.271.909-5.74 2.378C3.791 6.729 2.882 8.758 2.882 11s.909 4.271 2.378 5.74c1.469 1.469 3.498 2.378 5.74 2.378s4.271-.909 5.74-2.378c1.469-1.469 2.378-3.498 2.378-5.74s-.909-4.271-2.378-5.74C15.271 3.791 13.242 2.882 11 2.882z'
                />
                <path
                    fill='#FFF'
                    d='M10.353 7.118l1.294.004v5.172h-1.294V7.118zm0 6.47l1.294.001v1.293h-1.294v-1.294z'
                />
            </g>
        </svg>
    );
};
